export default function AboutSection() {
  return (
    <section id="about" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1024px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full bg-secondary-500/10 text-secondary-400 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-building-4-line text-xs"></i>
            关于平台
          </span>
          <h2 className="text-xl md:text-3xl font-bold text-foreground-100 mb-2">
            关于我们
          </h2>
          <p className="text-foreground-500 text-sm">了解四虎影视大全的故事与使命</p>
        </div>

        <div className="max-w-[800px] mx-auto bg-background-100 rounded-2xl border border-background-300/50 p-6 md:p-10">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 flex items-center justify-center bg-primary-500 rounded-xl">
              <i className="ri-movie-2-fill text-foreground-50 text-xl"></i>
            </div>
            <div>
              <h3 className="text-lg font-bold text-foreground-100">四虎影视大全</h3>
              <p className="text-foreground-500 text-xs">始于热爱，忠于品质</p>
            </div>
          </div>

          <div className="space-y-4 text-foreground-400 text-sm md:text-base leading-relaxed">
            <p>
              四虎影视大全创立于对影视艺术的无限热爱。我们深知每一位观众对于优质内容的渴望，因此倾力打造了这个汇聚海量高清影视资源的免费在线观看平台。从国产热剧到海外大片，从经典老片到最新上映，四虎影视大全始终致力于让每一位用户都能轻松找到心仪的内容。
            </p>
            <p>
              平台采用先进的智能CDN加速技术和高效视频编码方案，在全国范围内部署了数百个服务节点，确保无论您身在何处，都能享受到高清不卡顿的流畅观影体验。我们坚持"免费、高清、不缓冲"的服务理念，用心打磨每一个技术细节。
            </p>
            <p>
              四虎影视大全的内容团队全天候追踪全球影视动态，确保最新剧集、电影在第一时间与观众见面。我们相信，好的内容值得被更多人看到，而技术应该为内容服务，而非成为观看的阻碍。未来，四虎影视大全将继续拓展内容边界，优化观影体验，成为您最值得信赖的在线影视伙伴。
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-8 pt-6 border-t border-background-300/40">
            <div className="text-center">
              <div className="text-2xl font-black text-primary-500">10万+</div>
              <div className="text-foreground-600 text-xs mt-1">影视资源</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-black text-accent-500">5000万+</div>
              <div className="text-foreground-600 text-xs mt-1">月活用户</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-black text-secondary-500">99.9%</div>
              <div className="text-foreground-600 text-xs mt-1">服务可用率</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-black text-primary-500">7×24</div>
              <div className="text-foreground-600 text-xs mt-1">内容更新</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}